import React from 'react'
import { Alert, StackView } from '@planningcenter/tapestry-react'
import {
  Code,
  CodeBlock,
  Link,
  List,
  PageHeading,
  Text,
} from '../../../shared/typography'

export default function page() {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Personal Access Token</PageHeading>

      <Text>
        A Personal Access Token (PAT) allows you to use the API from your own
        account. This is useful if you are writing a script that runs on your
        own computer or a server you control. These tokens cannot be used in
        client-side requests from a web page.
      </Text>

      <Text>
        You may not use a Personal Access Token if you are integrating with
        multiple churches&mdash;instead use OAuth (see below).
      </Text>

      <Alert type="warning" marginBottom={2}>
        <Text size={4}>
          <strong>Important:</strong> Never share your Personal Access Token
          with another user or company. It is the equivalent of giving someone
          your username and password.
        </Text>
      </Alert>

      <List ordered>
        <List.Item>
          <Text>
            Visit{' '}
            <Link
              to="https://api.planningcenteronline.com/oauth/applications"
              external
            >
              your developer account
            </Link>
            .
          </Text>
        </List.Item>
        <List.Item>
          <Text>Create a new "Personal Access Token"</Text>
        </List.Item>
        <List.Item>
          <Text>
            Pass your token and secret in every request using HTTP Basic Auth.
          </Text>
        </List.Item>
      </List>

      <Text>
        You can pass your personal access token with <Code>curl</Code> like
        this:
      </Text>

      <CodeBlock language="bash">
        {
          'curl -u app_id:secret https://api.planningcenteronline.com/people/v2/people'
        }
      </CodeBlock>
    </StackView>
  )
}
